export const maskCRDocument = value => {
  return value
    .replace(/\W/g, "")
    .replace(/(cr[a-z]{1,3}|[A-Z]{1,3})(\d)/, "$1-$2")
    .replace(/(-\d{7})\d+?$/, "$1");
}

export const maskPhone = value => {
  const phone = value.replace(/\D/g, "");
  let cellOrLineRegx = /(\d{4})(\d)/;

  if (phone.length > 10) {
    cellOrLineRegx = /(\d{5})(\d)/;
  }

  return phone
    .replace(/(\d{2})(\d)/, "($1) $2")
    .replace(cellOrLineRegx, "$1-$2")
    .replace(/(-\d{4})\d+?$/, "$1");
};

export const maskDate = (value) => {
  return value
    .replace(/\D/g, "")
    .replace(/(\d{2})(\d)/, "$1/$2")
    .replace(/(\d{2})(\d)/, "$1/$2")
    .replace(/(\d{4})(\d)/, "$1");
};

export const maskCEP = value => {
  return value
    .replace(/\D/g, "")
    .replace(/(\d{5})(\d)/, "$1-$2")
    .replace(/(-\d{3})\d+?$/, "$1");
};

export const maskSchedule = value => {
  return value
    .replace(/\D/g, "")
    .replace(/(\d{2})(\d)/, "$1:$2")
    .replace(/(:\d{2})\d+?$/, "$1");
}

export const maskCPF = value => {
  return value
    .replace(/\D/g, "")
    .replace(/(\d{3})(\d)/, "$1.$2")
    .replace(/(\d{3})(\d)/, "$1.$2")
    .replace(/(\d{3})(\d{1,2})/, "$1-$2")
    .replace(/(-\d{2})\d+?$/, "$1");
}

export const maskCNPJ = value => {
  return value
    .replace(/\D/g, "")
    .replace(/(\d{2})(\d)/, "$1.$2")
    .replace(/(\d{3})(\d)/, "$1.$2")
    .replace(/(\d{3})(\d)/, "$1/$2")
    .replace(/(\d{4})(\d)/, "$1-$2")
    .replace(/(-\d{2})\d+?$/, "$1");
}

export const maskCPFOrCNPJ = value => {
  const digits = value.replace(/\D/g, "");

  if (digits.length <= 11) {
    return maskCPF(value);
  }

  return maskCNPJ(value);
}
